import styled, { css } from 'styled-components';

export const Content = styled.div`
  svg,
  img {
    cursor: pointer;
    &:last-child {
      margin-left: 30px;
    }
  }
  path {
    color: #333;
  }
  /* svg:hover {
    path {
      color: #f0f0f0;
    }
  } */

  /* &.active path {
    color: blue;
  } */
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      path {
        color: #f0f0f0;
      }
    `}
`;
